import { useMemo } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { BuilderMenu } from '@makyoapp/makyo-common'
import { Menu16 } from '@makyoapp/makyo-icon/icon'
import { SelectDropdown } from '@makyoapp/makyo-ui'

import { cn } from '@/lib/cn'
import { useAppBuilderContext } from '@/context/AppBuilderContext'
import { useVariableTextSingleCell } from '@/hooks/__project__/useVariableTextSingleCell'

const RenderMenuOption = ({ menu }: { menu: BuilderMenu }) => {
  const menuTitle = useVariableTextSingleCell(menu.title)
  return (
    <div className={cn('flex-c', menu.id ? '' : 'text-light')}>
      <Menu16 />
      <div>{menuTitle}</div>
    </div>
  )
}

export function MenuSelectV2({
  id,
  value,
  onChange,
  excludes = [],
  portal = true,
}: {
  id?: string
  value?: string
  onChange: (value: string) => void
  excludes?: string[]
  portal?: boolean
}) {
  const { t } = useTranslation()

  const { menus } = useAppBuilderContext()

  const options = useMemo(() => {
    return excludes.length > 0 ? menus.filter(({ id }) => !excludes.includes(id)) : menus
  }, [menus, excludes])

  const optionsWithPlaceholder = useMemo(() => {
    return [
      { id: '', title: t('Select Menu') } as BuilderMenu,
      // { id: '222', title: t('Global Settings') } as BuilderMenu,
      ...options,
    ]
  }, [t, options])

  return (
    <SelectDropdown
      id={id}
      placeholder={<Trans>Select Menu</Trans>}
      value={menus.find(({ id }) => id === value)}
      onChange={(opt, e) => {
        e.preventDefault()
        e.stopPropagation()
        onChange(opt.id)
      }}
      menuFullWidth={!portal}
      portalMenu={portal}
      menuZIndex='z-302'
      menuContainerClassName={!portal ? '' : 'mk-ag-sdd'}
      options={optionsWithPlaceholder}
      optionLabel={(opt) => `${opt?.id} ${opt?.title}`}
      renderOption={(opt) => <RenderMenuOption menu={opt} />}
    />
  )
}
